<template>
  <div
    :class="['tris-scroll-good', type === 'scroll' ? 'scroll' : '']"
    @click="goDetail"
  >
    <good-image
      :img-url="ssu.skuImg.imgUrl"
      :image-width="goodWidth"
      :stock-status="stockStatus"
      :is-video="isVideo"
      :custom-style="customImagStyle"
      :left-upper-tag="leftUpperTag"
      :sku-img="skuImg"
    />
    <div class="tris-scroll-info">
      <base-info
        :custom-style="baseInfoStyle"
        :name="ssu.skuBase.skuName"
        :show-self-tag="true"
        :format-info="formatInfo"
        :ssu-fp-text="ssuFpText"
        :sku-attr-tags="filterSelfAttrTags"
        name-multi-line
      />
      <div class="price-tag-wrapper">
        <price-tag :tag="priceSaveTag"></price-tag>
      </div>
      <good-price
        :ssu="ssu"
        :common-tracer-pamas="commonTracerPamas"
        :ssu-info="ssuInfo"
        :format-info="formatInfo"
        :custom-style="customPriceStyle"
        :custom-operator="customOperator"
        no-discount-stage
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import mixin from '../newMixin'
import PriceTag from '../widgets/price-tag.vue'
export default {
  name: 'NewTrisScrollGood',
  components: {
    PriceTag
  },
  mixins: [mixin],
  data() {
    return {
      customImagStyle: {
        with: '1.08rem',
        height: '1.08rem'
      },
      baseInfoStyle: {
        root: {
          height: '1.08rem' // name名称有1行改成2行
        },
        name: {
          // fontSize: '0.26rem',
          // height: '0.72rem',
          // 'line-height': '0.36rem',
          // display: '-webkit-box',
          // '-webkit-box-orient': 'vertical',
          // '-webkit-line-clamp': 2,
          // 'word-break': 'break-all',
          // 'text-overflow': 'ellipsis',
          // overflow: 'hidden',
          // 'box-sizing': 'border-box'
        },
        format: {
          fontSize: '0.22rem'
        }
      }
    }
  },
  computed: {
    customPriceStyle() {
      return {
        root: {
          marginTop: '.04rem'
        },
        totalPrice: {
          fontSize: this.type === 'scroll' ? '0.28rem' : '0.3rem'
        }
      }
    },
    customOperator() {
      return {
        simple: true,
        showPromoteTip: false,
        type: 'normal',
        useArrivedNoticeIcon: true
        // btnWith: this.type === 'scroll' ? 1.6 : 1.92,
        // canScroll: this.type === 'scroll'
      }
    }
  }
}
</script>

<style lang="scss">
.tris-scroll-good {
  // transform: translate3d(0, 0, 0);

  overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;

  flex: none;
  box-sizing: border-box;
  @include flex(column, flex-start, flex-start, nowrap);

  &.scroll {
    // height: 4.4rem;
  }
}
.tris-scroll-info {
  position: relative;

  width: 100%;
  box-sizing: border-box;

  padding: 0 0.16rem 0.16rem 0.16rem;

  overflow: hidden;

  flex: auto;
}
.price-tag-wrapper {
  height: 16px;
  margin-top: 4px;
}
</style>
